import React from 'react';

export const BackArrow = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height={`${props.height}`}
        width={`${props.width}`}
        style={{
            transform: `rotate(180deg)`
        }}
        viewBox={`0 0 24 24`}
    >
        <path
            stroke="#008EFF"
            fill="#008EFF"
            d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"
        />
    </svg>
);



// WEBPACK FOOTER //
// ./src/components/Shared/icons.js